import { QueryAggregator } from "@/api/utils/QueryAggregator"
import { AggregatedQueryProps } from "@/api/utils/QueryAggregator"
import { FreshdeskService } from "@/services/FreshdeskService"
import {
  ActivityFeedItemType,
  FreshdeskTicketFeedItem,
  IItemsByDate,
} from "@/models/activityFeed/ActivityFeedItem"
import { sortedFeedItems } from "./getActivityFeedEvents"

export const getFreshdeskFeed = (
  contactId: string,
): AggregatedQueryProps<IItemsByDate[]> => {
  const queries = new QueryAggregator()

  const legacyFreshdeskTicketsQuery =
    FreshdeskService.getLegacyTickets(contactId)
  queries.add(legacyFreshdeskTicketsQuery)

  const itemsList: ActivityFeedItemType[] = [
    ...legacyFreshdeskTicketsQuery.data.map((item) => {
      return new FreshdeskTicketFeedItem(item)
    }),
  ]

  return queries.setData(sortedFeedItems(itemsList)).getAggregate()
}
